import { Card } from '../common/Card.js';

interface ChatMessageProps {
  from: 'bot' | 'user';
  text: string;
  imageDataUrl?: string;
}

/**
 * A single conversational bubble. Bot messages are left-aligned, user messages
 * right-aligned. User bubbles may carry an inline image. Assistant text is
 * rendered plainly with newlines preserved (no markdown).
 */
export function ChatMessage({ from, text, imageDataUrl }: ChatMessageProps): JSX.Element {
  const isBot = from === 'bot';
  return (
    <div className={`flex ${isBot ? 'justify-start' : 'justify-end'}`}>
      <Card
        className={`max-w-[80%] ${
          isBot ? 'border-sage-300 bg-paper-100' : 'border-bark-300 bg-paper-200'
        }`}
      >
        <div className="font-body text-ink-900">
          {imageDataUrl ? (
            <img
              src={imageDataUrl}
              alt="Your photo"
              className="mb-2 max-h-48 max-w-full rounded-md object-cover"
            />
          ) : null}
          {text ? <p className="whitespace-pre-wrap">{text}</p> : null}
        </div>
      </Card>
    </div>
  );
}
